import { Icon } from '@orbita-ui/core';
import { StyledHeaderNotificationItem } from './HeaderNotificationItem.style';
import { IHeaderNotification } from './HeaderNotificationContainer';
import { formatFullDate } from 'shared/utils';

export const HeaderNotificationItem = ({
  notification,
  onClose,
  removeCloseIcon,
  removeDate,
}: {
  notification: IHeaderNotification;
  onClose: () => void;
  removeCloseIcon?: boolean;
  removeDate?: boolean;
}) => {
  let icon = null;
  switch (notification.type) {
    case 'error':
      icon = 'WarningTriangleFilledIcon';
      break;
    case 'info':
      icon = 'InfoFilledIcon';
      break;
    case 'success':
      icon = 'CheckCircleFilledIcon';
      break;
    case 'warning':
      icon = 'WarningFilledIcon';
      break;
  }
  return (
    <StyledHeaderNotificationItem
      data-testid="notification-item"
      className={notification.type + ' ' + (!notification.checked && 'unchecked')}
    >
      <div className="icon">
        <Icon name={icon} />
      </div>
      <div className="text">
        {!removeDate && <p className="date">{formatFullDate(notification.date)}</p>}
        <p>{notification.message}</p>
      </div>
      {!removeCloseIcon && (
        <div className="action">
          <Icon name="CrossIcon" onClick={() => onClose()} />
        </div>
      )}
    </StyledHeaderNotificationItem>
  );
};
